/**
 * Fonction permettant de déterminer si un élément dépasse horizontalement de l'écran ou non
 *
 * @param el
 */
export const isInViewport = (el: Element) => {
	const rect = el.getBoundingClientRect()

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		// rect.bottom <= (window.innerHeight /* || document.documentElement.clientHeight*/) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	)
}

/**
 * Fonction permettant de calculer la distance entre 2 points selon leur latitude et longitude
 *
 * @param lat1
 * @param lon1
 * @param lat2
 * @param lon2
 *
 * @return number
 */
export const calculDistanceEntreDeuxPoints = (lat1: number, lon1: number, lat2: number, lon2: number) => {
	const R = 6371 // Radius de la terre en km
	const dLat = deg2rad(lat2 - lat1)
	const dLon = deg2rad(lon2 - lon1)

	const a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
		Math.sin(dLon / 2) * Math.sin(dLon / 2)

	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
	// Distance in km
	return R * c
}

/** Fonction permettant de convertir des degrés en radians */
const deg2rad = (deg: number) => deg * (Math.PI / 180)